import { Sun, Cloud, CloudRain, CloudSnow, Wind, CloudFog, CloudLightning } from "lucide-react";

export const WEATHER_ICON = {
  clear: Sun, cloud: Cloud, rain: CloudRain, snow: CloudSnow,
  wind: Wind, fog: CloudFog, storm: CloudLightning,
};

export const sevText = (s) => (s >= 2 ? "text-red-500" : s >= 1 ? "text-amber-500" : "text-emerald-500");

export const sevBadge = (s) =>
  s >= 2 ? "bg-red-500/10 text-red-500 border-red-500/20"
    : s >= 1 ? "bg-amber-500/10 text-amber-600 border-amber-500/20"
    : "bg-emerald-500/10 text-emerald-600 border-emerald-500/20";
